<template>
    <div class="wizardStep" :class="{ 'active': combo.isActive }">
        <div class="title-container" @click="toggleHideGroup">
            <div class="left-part-title">
                <span class="circle" v-text="getGroupNumber()"></span>
                <h2 style="display:inline-block;" :class="{ 'disabledTitle': disabledTitle }"
                    v-text="getProductLanguage(combo, 'productGroupName')"></h2>
                <CircleButton v-if="showChangeMutexButton()" :big="true" :icon="change_white"
                    @circleBtnClick="openSelectMutexModal(depth)"></CircleButton>
            </div>
            <div class="count" :class="{ 'disabledTitle': disabledTitle }" v-text="buildText()"></div>
        </div>

        <div v-if="combo.groupImage" class="img-container">
            <img :src="combo.groupImage">
        </div>

        <div class="container-input-selected" :class="{ 'list': itemsList }">
            <div v-for="(productcombo, keyproductcombo) in this.comboOption" :key="keyproductcombo"
                v-show="productcombo.choosen" class="card-combo">
                <div v-if="productcombo.choosen" class="combo-selected">
                    <div class="selected-products">
                        <span class="customize-combo">{{ getString('personalize_seu_combo') }}</span>
                        <div class="combo-list">
                            <span class="combo-itens"
                                v-for="(item, keyChoosen) in getArrayFromChoosen(productcombo.choosen)"
                                :key="keyChoosen"
                                v-text="(item.quantity ? item.quantity + 'x ' : '') + getProductLanguage(item, 'subItemName')"></span>
                        </div>
                    </div>
                    <div class="edit-button-combo"
                        :class="{ 'big-mode': iconesGrandes, 'androidMode': isAndroidMode() }">
                        <CircleButton class="edit_button" :big="iconesGrandes" :icon="edit_white"
                            @circleBtnClick="editCombo(keyproductcombo)"></CircleButton>
                        <CircleButton v-if="productcombo.subItemMandatory !== 'S'" :big="iconesGrandes"
                            :icon="delete_white" @circleBtnClick="deleteCombo(keyproductcombo)"></CircleButton>
                    </div>
                </div>
            </div>
        </div>

        <div class="comb-prod-item-container">
            <div class="item-comb-prod" v-for="(prod, key) in removeBlockedProds(combo.productGroupItems)" :key="key"
                :class="{ 'selected': hasSelected(comboOption, prod), 'has-price': hasPrice(prod, combo), 'has-qtty': allowMultipleAdd && combo.productGroupMax > 1 }">
                <template v-if="allowMultipleAdd && combo.productGroupMax > 1">
                    <!-- <div class="selected-chekmark" v-if="comboOption.includes(prod)">
                        <CheckedMark class="check-mark-container"></CheckedMark>
                    </div> -->
                    <div v-if="!itemsList" class="image-label-container align-center" style="flex: 1">
                        <img v-if="prod.subItemProductImages && prod.subItemProductImages.large != null"
                            :src="getImagesURL(prod, 'subItemProductImages', 'large')" alt="">
                        <img v-else :src="noImageSrc">
                    </div>

                    <QuantityControl class="qtt" :quantity="prod.quantity || 0" :disabledMinus="disabledMinus(prod)"
                        @circleBtnRemove="decreaseAddQtty(prod)" @circleBtnAdd="increaseAddQtty(prod, key)">
                    </QuantityControl>

                    <label class="name-container" :for="getCheckboxID(key, prod.subItemCode)" :class="{
                        'disabled-click': prod.subItemMandatory === 'S' && prod.subItemPreSelected === 'S' && isSelected(key, prod.subItemCode),
                        'expand-width': itemsList,
                        'align-center': !itemsList
                    }">
                        <span class="name" v-text="getProductLanguage(prod, 'subItemName')"></span>
                        <span class="from" v-if="exibApartir() && prod.minPrice && showChildsPrice(combo)">{{ getString('a_partir_de') }}</span>
                        <span class="price full-min-price" v-if="hasPrice(prod, combo) && getFullMinPrice(prod, combo)" v-text="formatMoney(getFullMinPrice(prod, combo))"></span>
                        <span class="price" v-if="prod.minPrice && showChildsPrice(combo)" v-text="getProdPrice(prod)"></span>
                        <span class="price" v-if="hasPrice(prod, combo)" v-text="getProdPrice(prod)"></span>
                    </label>
                </template>

                <template v-else>
                    <div class="container-input">
                        <input class="styled-input" :id="getCheckboxID(key, prod.subItemCode)" type="checkbox"
                            :class="{ 'disabled-click': prod.subItemMandatory === 'S' && prod.subItemPreSelected === 'S' && isSelected(key, prod.subItemCode) }"
                            :value="prod" v-model="comboOption" @change="onProdChoose(prod, $event, key)">

                        <label class="checkmark radio" :for="getCheckboxID(key, prod.subItemCode)"
                            :class="{ 'disabled-click': prod.subItemMandatory === 'S' && prod.subItemPreSelected === 'S' && isSelected(key, prod.subItemCode) }">
                        </label>
                    </div>
                    <!-- <div class="selected-chekmark" v-if="comboOption.includes(prod)">
                        <CheckedMark class="check-mark-container"></CheckedMark>
                    </div> -->
                    <label class="image-label-container" :for="getCheckboxID(key, prod.subItemCode)" :class="{
                        'disabled-click': prod.subItemMandatory === 'S' && prod.subItemPreSelected === 'S' && isSelected(key, prod.subItemCode),
                        'expand-width': itemsList
                    }">
                        <template v-if="!itemsList">
                            <img v-if="prod.subItemProductImages && prod.subItemProductImages.large != null"
                                :src="getImagesURL(prod, 'subItemProductImages', 'large')" alt="">
                            <img v-else :src="noImageSrc">
                        </template>
                    </label>
                    <label :for="getCheckboxID(key, prod.subItemCode)" class="name-container">
                        <span class="name"  v-text="getProductLanguage(prod, 'subItemName')"></span>
                        <span class="from" v-if="exibApartir() && prod.minPrice && showChildsPrice(combo)">{{ getString('a_partir_de') }}</span>
                        <span class="price full-min-price" v-if="hasPrice(prod, combo) && getFullMinPrice(prod, combo)" v-text="formatMoney(getFullMinPrice(prod, combo))"></span>
                        <span class="price" v-if=" prod.minPrice && showChildsPrice(combo)" v-text="getProdPrice(prod)"></span>
                        <span class="price" v-if="hasPrice(prod, combo)" v-text="getProdPrice(prod)"></span>
                    </label>
                </template>
            </div>
        </div>

        <div class="overlay" v-if="showModal || showObservationsModal"></div>
        <Transition name="fade">
            <ModalComboDoComboGom v-if="showModal" :modalData="modalData" @modalCancel="modalCancel"
                :depth="depth" @modalConfirm="modalConfirm">
            </ModalComboDoComboGom>
        </Transition>

        <Transition name="bounce">
            <ObservationsModalGom v-if="showObservationsModal" :obsModalProd="obsModalProd"
                @obsModalClose="obsModalClose">
            </ObservationsModalGom>
        </Transition>
    </div>
</template>

<script>
/* eslint-disable */
import Util from '@/assets/libs/util'
import QuantityControl from '@/components/QuantityControl'
import ModalComboDoComboGom from '@/components/ModalComboDoComboGom'
import ObservationsModalGom from '@/components/ObservationsModalGom'
import CircleButton from '@/components/CircleButton'
import eventModule from '@/assets/libs/eventModule'
import LocaleController from '@/assets/controllers/LocaleController'
import CheckedMark from './CheckedMark.vue'
import CartController from '@/assets/controllers/CartController'
import DifferentiatedPricesController from '@/assets/controllers/DifferentiatedPricesController'

export default {
    name: 'WizardStepGom',
    props: ['combo', 'chosen', 'fatherProdCode', 'fatherPrint', 'zindex', 'depth', 'curComboKey', 'mutexData',
        'isEditing', 'blockProds', 'alternativeLayoutCounter'
    ],
    components: {
        QuantityControl,
        ModalComboDoComboGom,
        ObservationsModalGom,
        CircleButton,
        CheckedMark
    },
    data() {
        return {
            allowMultipleAdd: Util.getLocalConfigs('allowMultipleAdd'),
            comboOption: this.chosen || [],
            hideGroup: false,
            disabledTitle: false,
            showModal: false,
            modalData: null,
            obsModalProd: null,
            showObservationsModal: false,
            noImageSrc: null,
            useAlternativeLayout: true, // Util.getLocalConfigs('useAlternativeLayout'),
            itemsList: Util.getLocalConfigs('itemsList'),
            junk: require('../../static/icons/junk-icon.png'),
            edit_white: require('../../static/icons/edit_white.svg'),
            change_white: require('../../static/icons/change_white.svg'),
            delete_white: require('../../static/icons/delete_white.svg'),
            iconesGrandes: Util.getLocalConfigs('iconesGrandes'),
            signalsDiscount: Util.getLocalConfigs('signalsDiscount'),
        }
    },
    created() {
        eventModule.$on('checkNextPreselect', this.checkNextPreselect)
        eventModule.$on('deleteAllChoices', this.deleteAllChoices)
    },
    beforeDestroy() {
        eventModule.$off('checkNextPreselect', this.checkNextPreselect)
        eventModule.$off('deleteAllChoices', this.deleteAllChoices)
    },
    mounted() {
        this.noImageSrc = Util.getConfigImage('noImage') ? Util.getConfigImage('noImage') : this.junk
        if (!this.isEditing) {
            setTimeout(() => {
                this.fillPreselectedProducts(this.combo.productGroupItems, this.combo.productGroupMax)
            }, 200)
        }
        this.evaluateHideGroup()
        this.fillCheckboxes()
        setTimeout(() => {
            let groupDiv = document.getElementById(`curProd-0`)
            if (groupDiv) groupDiv.scrollIntoView({ 'behavior': 'smooth', 'block': 'start' })
        }, 400)
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        hasPrice: function (prod, combo) {
            return !!prod.price && this.showChildsPrice(combo) && !this.isFosException(prod, combo)
        },
        getImagesURL: function (prod, prop, size) {
            return Util.getImagesUrl(prod, prop, size)
        },
        getGroupNumber: function () {
            return this.depth + 1
        },
        getProdPrice: function (prod) {
            let showMinPriceDifference = Util.getLocalConfigs('showMinPriceDifference')
            let groupHasMinPrice = this.combo && this.combo.minPrice != null
            let diffPrice = DifferentiatedPricesController.getDiffPrice(prod.subItemCode || prod.productCode, true, prod)
            let price = 0
            let groupMin = this.combo && this.combo.productGroupMin > 0

            if (showMinPriceDifference && groupHasMinPrice && groupMin) {
                price = (diffPrice || prod.price) - this.combo.minPrice
            } if (groupHasMinPrice ){
                price = (diffPrice || prod.price || prod.minPrice)                
            }  else {
                price = (diffPrice || prod.price)
            }

            return price > 0 ? ` + ${Util.formatMoney(price)}` : ''
        },
        getFullMinPrice: function (prod, combo) {
            let showMinPriceDifference = Util.getLocalConfigs('showMinPriceDifference')
            let groupHasMinPrice = this.combo && this.combo.minPrice != null
            let groupMin = this.combo && this.combo.productGroupMin > 0
            let fullMinPrice = 0
            let diffPrice = DifferentiatedPricesController.getDiffPrice(prod.subItemCode || prod.productCode, true, prod)
            if (!this.signalsDiscount) {
                return null
            }
            let fullPrice = prod.fullPrice
            let price = prod.price
            // let price = prod.price
            if (!fullPrice || fullPrice === 0 || price == 0 || !price || (price + 1) >= fullPrice) {
                return null
            }
            if (showMinPriceDifference && groupHasMinPrice && groupMin) {
                fullMinPrice = (diffPrice || prod.fullPrice) - this.combo.minPrice
            } else {
                fullMinPrice = (diffPrice || prod.fullPrice)
            }
            return fullMinPrice
        },
        isSelected: function (key, subItemCode) {
            let id = this.getCheckboxID(key, subItemCode)
            let element = document.getElementById(id)
            return element && element.checked
        },
        checkNextPreselect: function (jumpingToGroupNumber) {
            if (this.depth === jumpingToGroupNumber) {
                if (!this.isEditing) {
                    this.fillPreselectedProducts(this.combo.productGroupItems, this.combo.productGroupMax, jumpingToGroupNumber)
                }
            }
        },
        checkHideGroup: function (groupKey) {
            let hideGroupOnMax = Util.getLocalConfigs('hideGroupOnMax')
            if (hideGroupOnMax && this.depth === groupKey && !this.hideGroup) {
                this.toggleHideGroup()
            }
        },
        deleteAllChoices: function (groupKey) {
            if (this.depth === groupKey) {
                if (this.allowMultipleAdd && this.combo.productGroupMax > 1) {
                    for (let i = this.comboOption.length; i > 0; i--) {
                        let prod = this.comboOption[i - 1]
                        let quantity = prod.quantity || 1

                        for (let i = 0; i < quantity; i++) {
                            this.decreaseAddQtty(prod)
                        }
                    }
                } else if (this.comboOption && this.comboOption.length > 0) {
                    this.comboOption = []
                    this.emitComboOption(this.comboOption, this.depth)
                }
            }
        },
        removeBlockedProds: function (prods) {
            return Util.removeBlockedProds(prods)
        },
        getCheckboxID: function (key, subItemCode) {
            let id = [this.depth, key, subItemCode]
            return id.join('')
        },
        disabledMinus: function (prod) {
            return prod.subItemProductGroups.length > 0 // && prod.quantity > 0
        },
        getArrayFromChoosen: function (choosen) {
            return Util.flatAnObjectList(choosen)
        },
        modalCancel: function (clickedElementId) {
            let clickedElement = document.getElementById(clickedElementId)
            if (clickedElement && clickedElement.checked) clickedElement.checked = false
            this.clearCheckboxes()
            this.fillCheckboxes()
            this.showModal = false
            this.emitComboOption(this.comboOption, this.depth)
        },
        modalConfirm: function (option) {
            if (option.edit) {
                let key = option.key
                this.comboOption.splice(key, 1)
            }

            // O produto que chega em option é uma cópia (deepCopy). Para incrementar o contador de quantidade no front
            // é preciso incrementar a quantidade do produto no array original
            let originalProd = this.combo.productGroupItems[option.prodIndex]
            if (originalProd && originalProd.quantity) {
                if (!option.edit) {
                    originalProd.quantity++
                }
            } else if (originalProd) {
                originalProd.quantity = 1
            }

            this.comboOption.push(option)
            this.emitComboOption(this.comboOption, this.depth)
            this.clearCheckboxes()
            this.fillCheckboxes()
            this.showModal = false
        },
        obsModalClose: function (obsModalProd) {
            CartController.setProductSequence(obsModalProd, false, this.depth + 1, (this.obsModalProd.prodIndex + 1), 0)
            this.comboOption.push(obsModalProd)
            this.emitComboOption(this.comboOption, this.depth)
            this.showObservationsModal = false
        },
        toggleHideGroup: function () {
            /* if (!this.useAlternativeLayout) {
                let isMutexGroup = this.combo.productGroupMutex && this.mutexData[this.combo.productGroupMutex]
                let hasAnyMutexSelected = this.mutexData[this.combo.productGroupMutex] && this.mutexData[this.combo.productGroupMutex].selectedMutexCode != null
                let isSelectedMutex = this.mutexData[this.combo.productGroupMutex] && this.combo.productGroupCode === this.mutexData[this.combo.productGroupMutex].selectedMutexCode
    
                if (!isMutexGroup || !hasAnyMutexSelected || isSelectedMutex) {
                    this.hideGroup = !this.hideGroup
                }
            } */
        },
        evaluateHideGroup: function () {
            /* if (!this.useAlternativeLayout) {
                let isSingleProdPreselec = this.combo.productGroupItems.length === 1 && this.combo.productGroupItems[0].subItemPreSelected === 'S'
                let isOptionalGroup = this.combo.productGroupMin === 0
                let isMutexGroup = this.combo.productGroupMutex && this.mutexData[this.combo.productGroupMutex]
                let isFirstMutexGroup = isMutexGroup && this.mutexData[this.combo.productGroupMutex].groups[0].productGroupCode === this.combo.productGroupCode
                let hasAnyMutexSelected = this.mutexData[this.combo.productGroupMutex] && this.mutexData[this.combo.productGroupMutex].selectedMutexCode != null
                let isSelectedMutex = this.mutexData[this.combo.productGroupMutex] && this.combo.productGroupCode === this.mutexData[this.combo.productGroupMutex].selectedMutexCode
    
                if (isSingleProdPreselec || isOptionalGroup || isMutexGroup) {
                    this.hideGroup = true
                    if (isMutexGroup && hasAnyMutexSelected && !isSelectedMutex) {
                        this.disabledTitle = true
                    }
                }
    
                if ((isFirstMutexGroup && !hasAnyMutexSelected) || (isMutexGroup && hasAnyMutexSelected && isSelectedMutex)) {
                    this.hideGroup = false
                }
            } */
        },
        fillPreselectedProducts: function (productGroupItems, groupMax, depth = 0) {
            let filteredProductGroupItems = Util.removeBlockedProds(productGroupItems)

            filteredProductGroupItems.forEach(product => {
                if (product.subItemPreSelected === 'S' && groupMax === 1 && depth === this.depth) {
                    this.onProdChoose(product, 'preselected')
                }
            })
        },
        formatMoney: function (price) {
            return Util.formatMoney(price)
        },
        emitComboOption: function (option, key) {
            this.$emit('comboOption', { 'option': option, 'key': key })
        },
        clearCheckboxes: function () {
            if (this.combo.productGroupItems && this.combo.productGroupItems.length > 0) {
                this.combo.productGroupItems.forEach((prod, index) => {

                    let isSelected = this.comboOption.find(element => element.subItemCode === prod.subItemCode)

                    if (!isSelected) {
                        let id = '' + this.depth + index + prod.subItemCode
                        let clickedElement = document.getElementById(id)
                        if (clickedElement && clickedElement.checked) clickedElement.checked = false
                    }
                })
            }
        },
        fillCheckboxes: function () {
            if (this.comboOption && this.comboOption.length > 0) {
                this.comboOption.forEach(option => {
                    let index = (this.combo.productGroupItems || []).findIndex(el => el.subItemCode === option.subItemCode)
                    let id = '' + this.depth + index + option.subItemCode
                    let clickedElement = document.getElementById(id)
                    if (clickedElement && !clickedElement.checked) clickedElement.checked = true
                })
            }
        },
        prepareModal: function (prod, event, prodIndex) {
            this.modalData = prod
            this.modalData.firstLevelFatherPrint = this.fatherPrint
            this.modalData.fatherPrint = this.combo.productGroupPrint
            if (event && event !== 'preselected') {
                let clickedElementId = event.srcElement.id
                this.modalData.clickedElementId = clickedElementId
            }
            if (prodIndex != null) {
                this.modalData.prodIndex = prodIndex
            }
            CartController.setProductSequence(prod, false, this.depth + 1, (prodIndex + 1), 0)
            this.showModal = true
        },
        onProdChoose: function (prod, event, key) {
            let comboDoCombo = Util.isComboDoCombo(prod, this.fatherProdCode)
            let canSelectOnlyOne = this.combo.productGroupMax === 1
            let isChecked = event === 'preselected' ? true : event && event.srcElement.checked
            let hasObservations = this.hasObservations(prod)
            let typedObsEnabled = Util.getLocalConfigs('permiteObsDigitada')

            if (comboDoCombo) {
                this.comboOption = this.comboOption.filter(cop => cop !== prod)
                let canSelectMore = this.comboOption.length < this.combo.productGroupMax

                if (canSelectOnlyOne) {
                    this.comboOption = []
                    if ((event && event === 'preselected') || (event && event.srcElement.checked)) {
                        this.prepareModal(prod, event, key)
                    } else {
                        this.emitComboOption(this.comboOption, this.depth)
                    }
                } else if (canSelectMore && isChecked) {
                    this.prepareModal(prod, event, key)
                } else {
                    event.srcElement.checked = true
                }
            } else if (hasObservations || typedObsEnabled) {
                let canSelectMore = this.comboOption.length <= this.combo.productGroupMax

                if (canSelectOnlyOne) {
                    this.comboOption = []
                    if ((event && event === 'preselected') || prod.subItemMandatory === 'S' || (event && event.srcElement.checked)) {
                        this.obsModalProd = prod
                        // this.showObservationsModal = true
                        this.clearCheckboxes()
                        this.fillCheckboxes()
                        let delay = event === 'preselected' ? 800 : 200
                        this.obsModalProd = prod
                        this.obsModalProd.prodIndex = key
                        setTimeout(() => {
                            this.showObservationsModal = true
                        }, delay)
                    } else {
                        this.emitComboOption(this.comboOption, this.depth)
                    }
                } else if (!canSelectMore) {
                    this.comboOption.pop()
                    event.srcElement.checked = false
                }else {
                    this.comboOption = []          
                    this.obsModalProd = prod
                    let delay = event === 'preselected' ? 800 : 200
                    setTimeout(() => {
                            this.showObservationsModal = true
                    }, delay)
                }
            } else {
                let canSelectMore = this.comboOption.length <= this.combo.productGroupMax

                if (canSelectOnlyOne) {
                    this.comboOption = []
                    if ((event && event === 'preselected') || prod.subItemMandatory === 'S' || (event && event.srcElement.checked)) {
                        CartController.setProductSequence(prod, false, this.depth + 1, (key + 1), 0)
                        prod.quantity = 1
                        this.comboOption.push(prod)
                        this.clearCheckboxes()
                        this.fillCheckboxes()
                    } else {
                        this.emitComboOption(this.comboOption, this.depth)
                    }
                } else if (!canSelectMore) {
                    this.comboOption.pop()
                    event.srcElement.checked = false
                }

                this.emitComboOption(this.comboOption, this.depth)
            }
        },

        increaseAddQtty: function (prod, prodIndex) {
            let comboDoCombo = Util.isComboDoCombo(prod, this.fatherProdCode)
            //let hasObservations = (prod.subItemObservationsChoice || []).length > 0
            let typedObsEnabled = Util.getLocalConfigs('permiteObsDigitada')

            let hasObservations = this.hasObservations(prod)

            if (comboDoCombo) {
                let totalGroupItens = 0
                this.comboOption.forEach(option => {
                    if (option.quantity) {
                        totalGroupItens += option.quantity
                    } else {
                        totalGroupItens++
                    }
                })
                if (totalGroupItens == this.combo.productGroupMax) {
                    Util.showErrorNotification({ title: this.getString('atingiu_limite_categoria'), text: null })
                    return;
                }
                this.prepareModal(prod, null, prodIndex)
            } else {
                let thisProdIndex = this.comboOption.findIndex(element => element.subItemCode === prod.subItemCode)

                if (!prod.quantity) {
                    prod.quantity = 0
                }

                let maxItens = this.combo.productGroupMax
                let totalGroupItens = 0
                this.comboOption.forEach(option => {
                    if (option.quantity) {
                        totalGroupItens += option.quantity
                    } else {
                        totalGroupItens++
                    }
                })

                if (totalGroupItens < maxItens) {
                    prod.quantity++
                    this.$forceUpdate()

                    if (thisProdIndex === -1) {
                        if (hasObservations || typedObsEnabled) {
                            this.obsModalProd = prod
                            this.obsModalProd.prodIndex = prodIndex
                            this.showObservationsModal = true
                            return true
                        } else {
                            CartController.setProductSequence(prod, false, this.depth + 1, (prodIndex + 1), 0)
                            this.comboOption.push(prod)
                        }
                    } else {
                        this.comboOption[thisProdIndex].quantity = prod.quantity
                    }
                    this.emitComboOption(this.comboOption, this.depth)
                } else {
                    Util.showErrorNotification({ title: this.getString('atingiu_limite_categoria'), text: null })
                }
            }
            this.$emit('updateComboPrice')
        },
        decreaseAddQtty: function (prod) {
            let comboDoCombo = Util.isComboDoCombo(prod, this.fatherProdCode)

            if (!comboDoCombo) {
                let thisProdIndex = this.comboOption.findIndex(element => element.subItemCode === prod.subItemCode)

                let isMandatory = prod.subItemMandatory === 'S'
                let minProductQuantity = isMandatory ? 1 : 0

                if (prod.quantity && prod.quantity > minProductQuantity) {
                    prod.quantity--
                    this.decreaseReferenceProdQuantity(prod)
                } else if (isMandatory) {
                    Util.showErrorNotification({ title: this.getString('produto_obrigatorio') + ' ' + prod.subItemName, text: null })
                }
                this.$forceUpdate()

                if (thisProdIndex !== -1) {
                    this.comboOption[thisProdIndex].quantity = prod.quantity
                    if (this.comboOption[thisProdIndex].quantity === 0) {
                        this.comboOption.splice(thisProdIndex, 1)
                    }
                }
                this.emitComboOption(this.comboOption, this.depth)
            }
        },
        decreaseReferenceProdQuantity: function (prod) {
            if (this.combo.productGroupItems && this.combo.productGroupItems.length > 0) {
                let index = this.combo.productGroupItems.findIndex(element => element.subItemCode === prod.subItemCode)
                if (index !== -1) {
                    this.combo.productGroupItems[index].quantity = prod.quantity
                }
            }
        },
        getCurQnt: function () {
            return this.comboOption.length || this.comboOption.productCode ? 1 : 0
        },
        buildText: function () {
            let text1 = this.getString('escolha')
            let text2 = ''

            if (this.combo.productGroupMin === this.combo.productGroupMax) {
                text2 = this.combo.productGroupMax
            } else {
                text2 = this.getString('ate') + ` ${this.combo.productGroupMax}`
            }

            let text3 = this.combo.productGroupMax === 1 ? this.getString('opcao') : this.getString('opcoes')

            return text1 + text2 + text3
        },
        showChildsPrice: function (comboGroup) {
            if (this.fatherPrint === 'S' && comboGroup.productGroupPrint === 'S') {
                // Se o produto principal (pai) é imprime sim e o grupo promocional também é imprime sim, deve exibir o preço dos filhos
                return true
            } else if (this.fatherPrint === 'N') {
                // Se o produto principal (pai) é imprime não, sempre deve exibir o preço dos itens filhos
                return true
            } else {
                return false
            }
        },
        isFosException: function (product, group) {
            let firstLevelComboPrint = this.fatherPrint === 'S'
            let groupPrint = group && group.productGroupPrint === 'S'
            return Util.isFosException(product, this.fatherProdCode, firstLevelComboPrint, groupPrint)
        },
        editCombo: function (keySelected) {
            let comboSelected = this.comboOption[keySelected]
            comboSelected.edit = true
            comboSelected.key = keySelected
            this.modalData = comboSelected
            this.modalData.fatherPrint = this.combo.productGroupPrint
            this.showModal = true
        },
        deleteCombo: function (keySelected) {
            let clickedElementId = this.comboOption[keySelected].clickedElementId
            let clickedElement = document.getElementById(clickedElementId)
            if (clickedElement && clickedElement.checked) clickedElement.checked = false

            let thisProdIndex = this.comboOption[keySelected].prodIndex
            let originalProd = this.combo.productGroupItems[thisProdIndex]
            if (originalProd && originalProd.quantity && originalProd.quantity > 0) {
                originalProd.quantity--

                let isMutexGroup = this.combo.productGroupMutex && this.mutexData[this.combo.productGroupMutex]
                let hasAnyMutexSelected = this.mutexData[this.combo.productGroupMutex] && this.mutexData[this.combo.productGroupMutex].selectedMutexCode != null
                let isSelectedMutex = this.mutexData[this.combo.productGroupMutex] && this.combo.productGroupCode === this.mutexData[this.combo.productGroupMutex].selectedMutexCode

                if (originalProd.quantity === 0 && isMutexGroup && hasAnyMutexSelected && isSelectedMutex) {
                    this.$emit('clearSelectedMutex', this.mutexData[this.combo.productGroupMutex])
                }
            }

            this.comboOption.splice(keySelected, 1)
            this.$emit('updateComboPrice')
            this.$emit('updateNextButton')
        },
        showChangeMutexButton: function () {
            let isMutexGroup = this.combo.productGroupMutex && this.mutexData[this.combo.productGroupMutex]
            return isMutexGroup
        },
        openSelectMutexModal: function (oldProductGroupCode) {
            let mutexKey = this.combo.productGroupMutex
            this.$emit('openSelectMutexModal', mutexKey, false, oldProductGroupCode)
        },
        getProductLanguage: function (product, index) {
            return LocaleController.getIndexLanguages(product, index)
        },
        isAndroidMode: function () {
            return Util.isAndroidMode()
        },
        hasSelected: function (comboOption, prod) {
            if (comboOption.includes(prod)) {
                return true
            }
            return false
        },
        hasObservations: function (prod) {
            if (!Array.isArray(prod.subItemObservationsChoice) || prod.subItemObservationsChoice.length === 0) {
                return false
            }
            return prod.subItemObservationsChoice.some(obs => {
                let filteredObservations = Util.removeBlockedProdsObs(obs.subItemObservations)
                if (filteredObservations.length > 0) {
                    return true
                }
            })
        },
        exibApartir: function () {
            return (Util.exibApartir())
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.wizardStep {
    position: relative;
    background: white;
    overflow: auto;
    overflow-x: hidden;
    margin-right: 15px;

    .hideGroup {
        display: none !important;
    }

    .price {
        font-family: @default-font;
        font-size: 25px;
        color: var(--price-font-color);
        margin: 0;
    }
    .price.full-min-price {
        text-decoration: line-through;
        color: @disabled-color;
        font-size: 22px;
        padding: 0 !important;
    }

    .title-container {
        margin: 25px 0;
        padding-top: 20px;
        padding-bottom: 20px;
        display: grid;
        grid-template-columns: 75% 25%;

        h2 {
            color: @primary-color;
            vertical-align: middle;
            text-align: left;
            width: calc(100% - 140px);
            padding: 0;
            padding-left: 10px;
            font-size: calc(1vw + 1.5vh);
        }

        .count {
            color: @primary-color;
            font-size: 1em;
            margin: auto;
        }

        .circle {
            margin-left: 10px;
            display: inline-block;
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background-color: @primary-color;
            color: white;
            text-align: center;
            align-items: bottom;
            line-height: 50px;
            padding: 10px 10px 10px 10px;
            font-size: 40px;
        }

        .disabledTitle {
            color: @disabled-color;
        }

        .left-part-title {
            display: flex;
            align-items: center;
            width: 100%;
        }
    }

    .img-container {
        height: 450px;
        margin-bottom: 30px;

        img {
            display: block;
            margin: auto;
            max-height: 450px;
        }
    }

    .comb-prod-item-container {
        display: flex;
        margin-bottom: 20px;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-around;

        &.list {
            display: grid;
            grid-template-columns: auto;

            .item-comb-prod {
                display: grid;
                grid-template-columns: max-content max-content;
                text-align: left;
                margin: 0px 30px 30px 30px;
                padding-left: 25px;

                div {
                    padding-right: 15px;
                }
            }
        }

        .item-comb-prod {
            display: flex;
            align-items: center;
            flex-direction: column;
            flex-wrap: nowrap;
            align-content: center;
            justify-content: flex-start;

            width: 45%;
            margin-top: 0;
            padding-left: 0;
            margin: 15px;
            box-shadow: 2px 3px 5px 3px rgba(0, 0, 0, 0.1);
            border-radius: 25px;

            .qtt {
                margin: auto;
                min-height: 100px;
            }

            .container-input {
                display: none;
            }

            .image-label-container {
                display: flex;
                flex-direction: column;
                width: 100%;
                img {
                    width: 100%;
                    object-fit: cover;
                    padding-bottom: 10px;
                    border-top-left-radius: 25px;
                    border-top-right-radius: 25px;
                    height: 220px;
                }

                span {
                    padding: 10px 15px;
                    text-align: center;
                    min-height: unset;
                    font-size: 28px;
                }
            }

            .name-container {
                display: flex;
                flex-direction: column;
                border-bottom-left-radius: 25px;
                border-bottom-right-radius: 25px;
                min-height: 100px;
                align-items: center;
                justify-content: center;
                span {
                    padding: 10px 15px;
                    text-align: center;
                    min-height: unset;
                    font-size: 28px;
                }
            }

            .align-center {
                align-items: center;
            }

            .expand-width {
                width: 100% !important;
            }

            &.selected {
                // background-color: rgba(128, 128, 128, 0.1);
                box-shadow: 1px 1px 3px 4px rgba(19, 165, 0, 0.2);
                transform: scale(1.02);
                background-color: rgba(19, 165, 0, 0.12);
            }
        }
    }

    .overlay {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 2;
    }

    .container-input-selected {
        display: grid;
        margin: 0 20px 0 20px;
        grid-template-columns: 49.5% 49.5%;
        column-gap: 20px;
        padding-bottom: 30px;
        justify-content: space-between;

        .combo-selected {
            border-top: 4px solid @primary-light;
            -webkit-box-shadow: 7px 0 7px rgba(0, 0, 0, 0.1);
            box-shadow: 7px 0 7px rgba(0, 0, 0, 0.1);
            width: 100%;
            // height: 100%;
            position: relative;
            min-height: inherit;
            display: grid;
            grid-template-rows: auto 100px;

            span {
                display: block;
            }

            .selected-products {
                padding: 20px 10px 10px 20px;
                min-height: 100px;

                .combo-list {
                    padding-left: 13px;
                }
            }
        }

        .card-combo {
            // border-bottom: 85px solid @primary-light;
            display: grid;
            margin-bottom: 10px;
        }

        .combo-itens {
            font-size: 25px;
            color: #524f4f;
        }

        .customize-combo {
            font-weight: bold;
            padding-bottom: 7px;
        }

        .edit-button-combo {
            // position: absolute;
            display: flex;
            width: -webkit-fill-available;
            justify-content: flex-end;
            height: 80px;
            margin-top: 15px;
            align-items: center;
            box-shadow: 7px 0 7px rgba(0, 0, 0, 0.1);
            background-color: @primary-light;

            button {
                margin: 5px;
            }
        }

        .edit-button-combo.big-mode {
            padding-left: 60%;
            bottom: -74px;
        }

        &.list {
            padding-bottom: 0;
        }
    }

    .disabled-click {
        pointer-events: none
    }
}

@media (min-width: 699px) and (max-width: 1025px) {

    //@tablet
    .wizardStep {
        .price {
            font-size: 20px;
        }
        .price.full-min-price {
            font-size: 18px;
        }

        .name {
            font-size: 20px;
        }

        .title-container {
            margin: 20px 0 0 0;
            padding-top: 10px;
            padding-bottom: 10px;

            .count {
                font-size: 22px;
            }

            .circle {
                margin-left: 20px;
                width: 25px;
                height: 25px;
                line-height: 25px;
                padding: 12px;
                font-size: 25px;
            }
        }

        .comb-prod-item-container {
            .item-comb-prod {
                margin: 10px;
                box-shadow: 2px 3px 5px 3px rgba(0, 0, 0, 0.1);
                border-radius: 20px;

                .qtt {
                    margin: auto;
                    min-height: 80px;
                }

                .container-input {
                    display: none;
                }

                .image-label-container {

                    img {
                        padding-bottom: 10px;
                        border-top-left-radius: 20px;
                        border-top-right-radius: 20px;
                        height: 150px;
                    }

                    span {
                        padding: 10px 15px;
                        text-align: center;
                        min-height: unset;
                        font-size: 22px;
                    }
                }

                .name-container {
                    span {
                        padding: 10px 15px;
                        text-align: center;
                        min-height: unset;
                        font-size: 22px;
                    }
                }

                .align-center {
                    align-items: center;
                }

                .expand-width {
                    width: 100% !important;
                }

                &.selected {
                    box-shadow: 1px 1px 3px 4px rgba(19, 165, 0, 0.2);
                }
            }
        }

        .container-input-selected {
            margin: 0 10px;
            grid-template-columns: 48.5% 48.5%;

            .combo-selected {
                grid-template-rows: auto 100px;

                .selected-products {
                    .combo-list {
                        .combo-itens {
                            font-size: 20px;
                        }
                    }
                }
            }

            .edit-button-combo {
                display: flex;
                width: -webkit-fill-available;
                justify-content: flex-end;
                height: 80px;
                align-items: center;
            }
        }
    }
}

@media (max-width: 698px) {

    // Gertec SK210
    .wizardStep {
        margin-right: 0;
        .price {
            font-size: 16px;
        }

        .price.full-min-price {
            font-size: 14px !important;
        }

        .name {
            font-size: 15px;
        }

        .title-container {
            margin: 10px 0 0 0;
            padding-top: 10px;
            padding-bottom: 10px;

            .count {
                font-size: 16px;
            }

            .circle {
                margin-left: 5px;
                width: 18px;
                height: 18px;
                line-height: 18px;
                padding: 10px;
                font-size: 20px;
            }

            h2 {
                width: calc(100% - 100px);
                font-size: 18px;
            }
        }

        .comb-prod-item-container {
            .item-comb-prod {
                margin: 5px;
                box-shadow: 2px 2px 3px 1px rgba(0, 0, 0, 0.1);
                border-radius: 10px;

                .qtt {
                    margin: auto;
                    min-height: 50px;
                }

                .container-input {
                    display: none;
                }

                margin-bottom: 10px;

                .image-label-container {

                    img {
                        padding-bottom: 5px;
                        border-top-left-radius: 15px;
                        border-top-right-radius: 15px;
                        height: 100px;
                    }

                    span {
                        padding: 5px 7px;
                        text-align: center;
                        min-height: unset;
                        font-size: 16px;
                    }
                }

                .name-container {
                    min-height: 50px;
                    span {
                        padding: 5px 7px;
                        text-align: center;
                        min-height: unset;
                        font-size: 16px;
                    }
                }

                .align-center {
                    align-items: center;
                }

                .expand-width {
                    width: 100% !important;
                }

                &.selected {
                    box-shadow: 1px 1px 2px 2px rgba(19, 165, 0, 0.2);

                    &.has-qtty {
                        grid-template-rows: 0 140px 80px 60px;
                    }

                    &.has-price {
                        grid-template-rows: 0 140px 130px;
                    }

                    &.has-price.has-qtty {
                        grid-template-rows: 0 140px 80px;

                        .image-label-container {
                            margin-top: 0 !important;
                        }
                    }

                    .selected-chekmark {
                        margin: -10px 0;
                        width: 100%;
                        height: 15px;
                        margin-top: 0;

                        .check-mark-container {
                            width: 20px;
                            height: 15px;
                        }
                    }
                }
            }
        }

        .container-input-selected {
            margin: 0 5px;
            grid-template-columns: 46% 46%;
            font-size: 14px;

            // justify-content: space-between;
            .card-combo {
                margin-bottom: 0;

                // border-bottom: 45px solid @primary-light;
                .combo-selected {
                    grid-template-rows: auto 40px;

                    .selected-products {
                        padding: 10px 5px 5px 10px;

                        .combo-list {
                            .combo-itens {
                                font-size: 14px;
                            }
                        }
                    }
                }
            }

            .edit-button-combo {
                display: flex;
                width: -webkit-fill-available;
                justify-content: flex-end;
                height: 40px;
                align-items: center;
                margin-top: 9px;
                margin-bottom: -5px;
            }
        }
    }
}
@media (orientation: landscape) {
    .wizardStep {
        .price {
            font-size: 20px;
        }

        .price.full-min-price {
            font-size: 18px;
        }

        .name {
            font-size: 20px;
        }

        .title-container {
            margin: 10px 0 0 0;
            padding-top: 10px;
            padding-bottom: 10px;

            .count {
                font-size: 22px;
            }

            .circle {
                margin-left: 20px;
                width: 25px;
                height: 25px;
                line-height: 25px;
                padding: 12px;
                font-size: 25px;
            }
        }

        .comb-prod-item-container {
            margin-bottom: 80px;
            .item-comb-prod {
                margin: 0 0px 20px 0px;
                box-shadow: 1px 1px 1px 2px rgba(0, 0, 0, 0.1);
                border-radius: 10px;
                width: 23%;
                .qtt {
                    margin: auto;
                    min-height: 80px;
                }

                .container-input {
                    display: none;
                }

                .image-label-container {

                    img {
                        padding-bottom: 10px;
                        border-top-left-radius: 10px;
                        border-top-right-radius: 10px;
                        height: 150px;
                    }

                    span {
                        padding: 10px 15px;
                        text-align: center;
                        min-height: unset;
                        font-size: 20px;
                    }
                }

                .name-container {
                    min-height: unset;
                    span {
                        padding: 10px 15px;
                        text-align: center;
                        min-height: unset;
                        font-size: 20px;
                    }
                }

                .align-center {
                    align-items: center;
                }

                .expand-width {
                    width: 100% !important;
                }

                &.selected {
                    box-shadow: 1px 1px 1px 2px rgba(19, 165, 0, 0.2);
                }
            }
        }

        .container-input-selected {
            margin: 0 10px;
            grid-template-columns: 48.5% 48.5%;

            .combo-selected {
                grid-template-rows: auto 80px;
                border-left: solid 1px rgba(0, 0, 0, 0.2);
                .selected-products {
                    padding: 10px;
                    .combo-list {
                        gap: 3px;
                        .combo-itens {
                            font-size: 20px;
                        }
                    }
                }
            }

            .edit-button-combo {
                display: flex;
                width: -webkit-fill-available;
                justify-content: flex-end;
                height: 80px;
                align-items: center;
                margin-top: 0;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/WizardStepGom.vue